
import { defineComponent } from 'vue'
import ToggleInputV2 from '~/components/Form/ToggleInputV2.vue'

export default defineComponent({
  name: 'PostInlineCommentsToggle',
  components: {
    ToggleInputV2
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle']
})
